import { Image } from '@user-portal/wikr-components';
import styled from 'styled-components';

export const Emoji = styled(Image)<{ $mt?: number }>`
    ${({ $mt = 0 }) => $mt && `margin-top: ${$mt}px;`};
`;
